import { getAuth } from 'firebase/auth';

const FUNCTIONS_BASE_URL = 'https://us-central1-coin2cashwts.cloudfunctions.net';

/**
 * Upload KYC image via Firebase Functions proxy (bypasses CORS)
 * @param file - Image file to upload
 * @param userId - User ID (kept for API compatibility)
 * @param type - Verification type (ID_CARD, SELFIE, ADDRESS, BUSINESS)
 * @returns Download URL of the uploaded image
 */
export const uploadKYCImage = async (
    file: File,
    userId: string,
    type: string
): Promise<string> => {
    console.log('🔵 [UPLOAD] Starting image upload via Functions proxy...', {
        fileName: file.name,
        userId,
        type,
        fileSize: file.size
    });

    // Get current user's ID token for auth
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) {
        throw new Error('로그인이 필요합니다.');
    }

    const idToken = await currentUser.getIdToken();

    // Convert file to base64
    const base64 = await fileToBase64(file);
    const imageDataBase64 = base64.split(',')[1]; // remove data:image/xxx;base64, prefix

    console.log('🔵 [UPLOAD] Sending to Functions proxy...');

    const response = await fetch(`${FUNCTIONS_BASE_URL}/uploadKYCImageFn`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${idToken}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            imageDataBase64,
            mimeType: file.type || 'image/jpeg',
            fileName: file.name,
            kycType: type,
        }),
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: '알 수 없는 오류' }));
        console.error('❌ [UPLOAD] Function error:', errorData);
        throw new Error(errorData.error || `업로드 실패 (${response.status})`);
    }

    const result = await response.json();
    console.log('✅ [UPLOAD] Upload complete!', result.imageUrl);
    return result.imageUrl;
};

function fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = () => reject(new Error('파일 읽기 실패'));
        reader.readAsDataURL(file);
    });
}
